/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Step_1Inputs */

const en_claims_step_1 = /** @type {(inputs: Claims_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the claim form.`)
};

const fr_claims_step_1 = /** @type {(inputs: Claims_Step_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez le formulaire de réclamation.`)
};

/**
* | output |
* | --- |
* | "Download the claim form." |
*
* @param {Claims_Step_1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_step_1 = /** @type {((inputs?: Claims_Step_1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Step_1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_step_1(inputs)
	return fr_claims_step_1(inputs)
});